var vars = require('./core');

module.exports = vars.createClass('Radar', ['getPointsAtEvent']);



// WEBPACK FOOTER //
// ./src/Scripts/react-chartjs/lib/radar.js